<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <employee-proficiency-parameter-create-or-update v-model="proficiencyParameter"  :errors="errors"></employee-proficiency-parameter-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="employee-proficiency-parameter"
                        search
                        pagination="server"
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
                    
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeProficiencyParameterCreateOrUpdate from './components/EmployeeProficiencyParameterCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        EmployeeProficiencyParameterCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:"Yetkinlik",key:"EmployeeProficiencyName", thClass:"w-33", sortKey:'EmployeeProficiency.Name',sortable:true},   
                {name:"Değer",key:"Name", thClass:"w-33",sortable:true},   
                {name:"Varsayılan",key:"IsDefaultValue", thClass:"w-34",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            proficiencyParameter:{
                Id:null,
                EmployeeProficiencyId:null,
                IsDefaultValue:false,
                Name:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.proficiencyParameter.Id = null
            this.proficiencyParameter.EmployeeProficiencyId = null
            this.proficiencyParameter.IsDefaultValue = false
            this.proficiencyParameter.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.EmployeeProficiencyParameter.Table(data)
        },
        edit(item){
            this.editing = true
            this.proficiencyParameter.Id = item.Id
            this.proficiencyParameter.EmployeeProficiencyId = item.EmployeeProficiencyId
            this.proficiencyParameter.IsDefaultValue = item.IsDefaultValue
            this.proficiencyParameter.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.EmployeeProficiencyParameter.CreateOrUpdate(this.editing,this.proficiencyParameter).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} yetkinlik değerini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.EmployeeProficiencyParameter.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>